import { Component, OnInit, Input } from '@angular/core';
import { MediaService } from 'app/components/media/media.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import { SearchService } from 'app/components/search/search.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSimpleComponent } from '../modal-simple/modal-simple.component';
import {AlertService} from "../alert/alert.service";
import * as uuid from 'uuid';


@Component({
  selector: 'app-edit-exhibitor-multimedia',
  templateUrl: './edit-exhibitor-multimedia.component.html',
  styleUrls: ['./edit-exhibitor-multimedia.component.css']
})
export class EditExhibitorMultimediaComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  maxImageSize: number = 614400;
  maxFileSize:number = 16777216
  maxFileCount: number = 3;

  @Input() exhibitorData: object = {
    images: [],
    files: []
  };

  constructor(private mediaService: MediaService, private catalogueService: CatalogueService, private exhitorsService: ExhitorsService,
  private searchService: SearchService, private modalService: NgbModal, private alertService: AlertService) { }

  removeImage(item) {

    let index = this.exhibitorData['images'].indexOf(item);

    if (index != -1) {
      this.exhibitorData['images'].splice(index, 1);
      this.reorganizeAfterRemove();
    }

  }

  imageFileChange($event) {

    const file = $event.srcElement.files[0];
    $event.target.value = '';

    if( this.exhibitorData['images'].length == this.exhibitorData['imageExhibitorLimit'] ) {
      let alertData = {
        alertType: 'error',
        alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.IMAGES_LIMIT_ERROR'
      }

      this.openSimpleModal(alertData);
      return;
    }

    if( file.size >= this.maxImageSize ) {
            let alertData = {
        alertType: 'error',
        alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.IMAGES_LIMIT_SIZE'
      }

      this.openSimpleModal(alertData);
      return;
    }
    let extraRoute = 'exhibitor/' + this.exhibitorData['exhibitorId'] + '/images';


    let addFileIn = {
      file: file,
      catalogueId: this.catalogueService.getProperty('id'),
      exhibitorId: this.exhibitorData['exhibitorId'],
      path: `ecatalogue/${this.catalogueService.getProperty('sapCode')}/${extraRoute}/${uuid.v4()}.${file.type.replace(/(.*)\//g, '')}`,
      name: file.name
    }

    this.addImage(addFileIn);

  }

  addImage(addFileIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mediaService.addFile(addFileIn)
      .subscribe((data: object) => {
        this.addImageOk(data);
      },
        error => {
          this.addImageError(error);
        });

  }

  addImageOk(data) {

    this.loader.count--;

    this.exhibitorData['images'].push({
      id: data.id,
      visibilityOrder: this.exhibitorData['images'].length,
      url: data.url
    });

    this.reorganizeAfterUpload();

  }

  addImageError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  reorganize(reorganizeIn, message) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mediaService.reorganize(reorganizeIn)
      .subscribe((data: object) => {
        this.reorganizeOk(data, message);
      },
        error => {
          this.reorganizeError(error);
        });

  }

  reorganizeOk(data, message) {

    this.loader.count--;

    let alertData = {
      type: 'success',
      message: message
    }
    this.alertService.addAlert(alertData);

  }

  reorganizeError(error) {

    this.loader.count--;

    let alertData = {
      alertType: 'error',
      alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.ERRORS.REMOVE_IMAGE'
    }
    this.openSimpleModal(alertData);

  }

  openSimpleModal(alertData) {
      const modalRef = this.modalService.open(ModalSimpleComponent);
      modalRef.componentInstance.titleTranslation = 'MODAL_SIMPLE.TITLE_INFORMATION';
      modalRef.componentInstance.modalInformation = alertData.alertMessage;
      modalRef.componentInstance.isHtml = false;
  }

  reorganizeAfterUpload() {
    this.reorganizeImages('EDIT_EXHIBITOR_MULTIMEDIA.UPLOAD_IMAGE_OK');
  }

  reorganizeAfterRemove() {
    this.reorganizeImages('EDIT_EXHIBITOR_MULTIMEDIA.REMOVE_IMAGE_OK');
  }

  private reorganizeImages(message) {

    let imagesUrl: Array<any> = [];

    for (let i = 0; i < this.exhibitorData['images'].length; i++) {
      imagesUrl.push(this.exhibitorData['images'][i]['url']);
    }

    let reorganizeIn = {
      exhibitorId: this.exhibitorData['exhibitorId'],
      order: imagesUrl
    }

    this.reorganize(reorganizeIn, message);

  }

  fileChange($event) {

    const file = $event.srcElement.files[0];
    $event.target.value = '';

    if( this.exhibitorData['files'].length === this.maxFileCount ) {
      let alertData = {
        alertType: 'error',
        alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.FILE_LIMIT_ERROR'
      }

      this.openSimpleModal(alertData);
      return;
    }

    if(file.size >= this.maxFileSize) {
      let alertData = {
        alertType: 'error',
        alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.FILE_SIZE_ERROR'
      }

      this.openSimpleModal(alertData);
      return;
    }

    let addFileIn = {
      file: file,
      catalogueId: this.catalogueService.getProperty('id'),
      exhibitorId: this.exhibitorData['exhibitorId'],
      name: file.name
    }

    this.addFile(addFileIn);

  }

  addFile(addFileIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mediaService.addFile(addFileIn)
      .subscribe((data: object) => {
        this.addFileOk(data);
      },
        error => {
          this.addFileError(error);
        });

  }

  addFileOk(data) {

    this.loader.count--;

    let file = {
      id: data.id,
      url: data.url
    }

    this.exhibitorData['files'].push(file);

  }

  addFileError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  removeFile(item) {

    let index = this.exhibitorData['files'].indexOf(item);

    if (index != -1) {

      let deleteFileIn = {
        fileId: item.id
      }

      this.deleteFile(deleteFileIn, index);

    }

  }

  deleteFile(deleteFileIn, index) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.mediaService.deleteFile(deleteFileIn)
      .subscribe((data: object) => {
        this.deleteFileOk(data, index);
      },
        error => {
          this.deleteFileError(error);
        });

  }

  deleteFileOk(data, index) {

    this.loader.count--;

    let alertData = {
      type: 'success',
      message: 'EDIT_EXHIBITOR_MULTIMEDIA.REMOVE_FILE_OK'
    }
    this.alertService.addAlert(alertData);

    this.exhibitorData['files'].splice(index, 1);

  }

  deleteFileError(error) {

    this.loader.count--;

    let alertData = {
      alertType: 'error',
      alertMessage: 'EDIT_EXHIBITOR_MULTIMEDIA.ERRORS.REMOVE_FILE'
    }
    this.openSimpleModal(alertData);

  }

  getImages(getImagesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getImages(getImagesIn)
      .subscribe((data: object) => {
        this.getImagesOk(data);
      },
        error => {
          this.getImagesError(error);
        });

  }

  getImagesOk(data) {

    this.loader.count--;
    if(data._embedded.images.length > 0){
      this.exhibitorData['images'] = data._embedded.images;
    }

  }

  getImagesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getCatalogueAndExhibitor(getCatalogueAndExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.searchService.getCatalogueAndExhibitor(getCatalogueAndExhibitorIn)
      .subscribe((data: object) => {
        this.getCatalogueAndExhibitorOk(data);
      },
        error => {
          this.getCatalogueAndExhibitorError(error);
        });

  }

  getCatalogueAndExhibitorOk(data) {
    this.loader.count--;
    this.exhibitorData['files'] = data._embedded.files;
  }

  getCatalogueAndExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
  
  }

  ngOnInit() {

    let getImagesIn = {
      exhibitorId: this.exhibitorData['exhibitorId']
    };

    this.getImages(getImagesIn);

    let getCatalogueAndExhibitorIn = {
      catalogueId: this.catalogueService.getProperty('id'),
      exhibitorId: this.exhibitorData['exhibitorId']
    }

    this.getCatalogueAndExhibitor(getCatalogueAndExhibitorIn);

  }

}
